import { createReducer } from '@reduxjs/toolkit';

import { Nullable } from 'modules/types/common';

import * as actions from './actions';
import { ShareImagingResults } from '../types';

type ImagingDetailsDownloadStatus = 'pending' | 'success' | 'fail';

export interface ImagingDetailsDownloadsState {
  isDownloadingImagingDetails: boolean;
  data: Record<string, ImagingDetailsDownloadStatus>;
}

export const imagingDetailsDownloadsInitialState = (): ImagingDetailsDownloadsState => ({
  isDownloadingImagingDetails: false,
  data: {}
});

export const imagingDetailsDownloadsReducer = createReducer(imagingDetailsDownloadsInitialState(), {
  [actions.DOWNLOAD_IMAGING_DETAILS]: (state, action) => {
    state.isDownloadingImagingDetails = true;
    state.data[action.payload.id] = 'pending';
  },
  [actions.DOWNLOAD_IMAGING_DETAILS_SUCCESS]: (state, action) => {
    state.isDownloadingImagingDetails = false;
    state.data[action.payload.id] = 'success';
  },
  [actions.DOWNLOAD_IMAGING_DETAILS_FAIL]: (state, action) => {
    state.isDownloadingImagingDetails = false;
    state.data[action.payload.id] = 'fail';
  }
});

export interface ShareImagingResultsState {
  isSendingImagingResults: boolean;
  sharedImagingResultsData: ShareImagingResults | {};
  sharedImagingResultsError: Nullable<Error>;
}

export const shareImagingResultsInitialState = (): ShareImagingResultsState => ({
  isSendingImagingResults: false,
  sharedImagingResultsData: {},
  sharedImagingResultsError: null
});

export const shareImagingResultsReducer = createReducer(shareImagingResultsInitialState(), {
  [actions.SHARE_IMAGING_RESULTS]: state => {
    state.isSendingImagingResults = true;
    state.sharedImagingResultsError = null;
  },
  [actions.SHARE_IMAGING_RESULTS_SUCCESS]: (state, action) => {
    state.isSendingImagingResults = false;
    state.sharedImagingResultsData = action.payload.data;
  },
  [actions.SHARE_IMAGING_RESULTS_FAIL]: (state, action) => {
    state.isSendingImagingResults = false;
    state.sharedImagingResultsError = action.error;
  }
});
